export const BS_FINANCES_GET = "bsFinancesGet"
export const BS_FINANCE_SEARCH = "bsFinanceSearch"
export const BS_FINANCE_GET = "bsFinanceGet"